import { VISIT_REASON_PATHS } from "@/constants";
import { DigitalVisitReasonEnum } from "@/lib/__generated/api";

export function resolveVisitReasonFromSlug(slug: string): DigitalVisitReasonEnum | null {
  const normalized = slug.toLowerCase();
  for (const [reason, slugs] of Object.entries(VISIT_REASON_PATHS) as [
    DigitalVisitReasonEnum,
    string[],
  ][]) {
    if (slugs.includes(normalized)) return reason;
  }
  return null;
}
